/**
 * @author Yaochao
 * @date 2021/8/4 14:46
 * @description
 */
import React from 'react'
import Util from "../../public/utils";

/**
 * titleWidth title宽度
 * @param conStyle 内容宽度
 * @returns {*}
 * @constructor
 */
const ZkForm = (props) => {

    const {titleWidth: titleWidth, conWidth: conWidth, className: className} = props;

    return (
        <div className={className ? className : ''}>
            {
                React.Children.map(props.children, child => {
                    if (!Util.isEmpty(child)) {
                        return React.cloneElement(child, {
                            titleWidth: child.props.titleWidth ? child.props.titleWidth : titleWidth,
                            conWidth: child.props.conWidth ? child.props.conWidth : conWidth
                        })
                    }
                })
            }
        </div>
    )
};

export default ZkForm